// extracted by mini-css-extract-plugin
module.exports = {"costs__status":"costTable_costs__status__2Iyli","costs__status_icon":"costTable_costs__status_icon__uwXfc","costs__comment":"costTable_costs__comment__1XJDi"};